import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepartmentsComponent } from './departments.component';
import { MaterialModule } from 'src/app/material.module';
import { SectionModule } from '../../portal/section/section.module';
import { AddDepartmentsComponent } from './add-departments/add-departments.component';

@NgModule({
  declarations: [DepartmentsComponent, AddDepartmentsComponent],
  imports: [CommonModule, MaterialModule, SectionModule],
  exports: [DepartmentsComponent],
})
export class DepartmentsModule {}
